import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-cy": "main-wrapper",
  id: "control-tva-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_ControlTVATable = _resolveComponent("ControlTVATable")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.isTaxControlButtonVisible)
          ? (_openBlock(), _createBlock(_component_v_btn_primary, {
              key: 0,
              block: "",
              "data-cy": "main-button",
              elevation: "0",
              class: "rounded-lg gradient mt-2",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openTaxControlCreateDialog())),
              disabled: _ctx.disableMainButton,
              size: "large"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("control-tva.main-button")), 1)
              ]),
              _: 1
            }, 8, ["disabled"]))
          : _createCommentVNode("", true),
        _createVNode(_component_oss_dialog, {
          modelValue: _ctx.isTaxDialogVisible,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isTaxDialogVisible) = $event)),
          height: "90vh",
          width: "60vw",
          persistent: "",
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeTaxControlDialog())),
          maxWidth: "80vw",
          title: _ctx.getDialogTitle()
        }, {
          default: _withCtx(() => [
            (_ctx.step === 'date-picker')
              ? (_openBlock(), _createBlock(_component_oss_date_picker_filled, {
                  key: 0,
                  modelValue: _ctx.selectedDate,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedDate) = $event))
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true),
            (_ctx.step === 'table')
              ? (_openBlock(), _createBlock(_component_ControlTVATable, {
                  key: 1,
                  inputDate: _ctx.selectedDate.toISOString()
                }, null, 8, ["inputDate"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue", "title"])
      ]))
    : _createCommentVNode("", true)
}